import { Bank } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconBank12Line = createIcon(Bank, 12, "Line");
export const IconBank16Line = createIcon(Bank, 16, "Line");
export const IconBank20Line = createIcon(Bank, 20, "Line");
export const IconBank24Line = createIcon(Bank, 24, "Line");
export const IconBank32Line = createIcon(Bank, 32, "Line");
export const IconBank48Line = createIcon(Bank, 48, "Line");
export const IconBank64Line = createIcon(Bank, 64, "Line");
